import { Component } from '@angular/core';

@Component({
  selector: 'app-notfound',
  template: 'Not Found 2',
  standalone: false
})
export class NotfoundComponent {}
